import * as React from 'react';
import styled from 'styled-components';

import DocsHelper from 'util/DocsHelper';
import useCurrentUser from 'hooks/useCurrentUser';
import { isPermitted } from 'util/PermissionsMixin';
import { PageHeader, Icon } from 'components/common';
import { Col, Button } from 'components/bootstrap';
import { useModalContext } from 'common/contexts';

import ProceduresList from './EventProcedureList';
import StepsList from './EventProcedureStepList';

const StyledIndexRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  gap: 0.5rem;
`;

const StyledIndexWrapper = styled.div`
  flex: 1;
  border: 1px solid ${(props: any) => props.theme.colors.variant.lighter.default};
  border-radius: 5px;
  padding: 5px 10px;
  background-color: ${(props: any) => props.theme.colors.global.contentBackground};
`;

type Props = {
  viewType: string;
  useCoreRoutes?: boolean;
};

function SecurityUI({ viewType, useCoreRoutes = false }: Props) {
  const { setModal } = useModalContext();

  const openEventProcedureModal = () => {
    setModal('CREATE-EVENT-PROCEDURE');
  };

  const openEventProcedureStepModal = () => {
    setModal('CREATE-EVENT-PROCEDURE-STEP');
  };

  const { permissions } = useCurrentUser();
  const canCreateEventProcedures = React.useMemo(
    () => isPermitted(permissions, 'event_procedures:create'),
    [permissions],
  );
  const canCreateEventProcedureSteps = React.useMemo(
    () => isPermitted(permissions, 'event_procedure_steps:create'),
    [permissions],
  );

  return (
    <>
      <Col md={12}>
        {viewType === 'procedures' ? (
          <PageHeader
            title="Event Procedures"
            documentationLink={{
              title: 'Event Procedures Documentation',
              path: DocsHelper.PAGES.EVENT_PROCEDURES,
            }}
            actions={
              canCreateEventProcedures && (
                <Button bsStyle="primary" onClick={() => openEventProcedureModal()}>
                  <Icon name="add" size="xs" />
                  Create Event Procedure
                </Button>
              )
            }
          />
        ) : (
          <PageHeader
            title="Event Procedure Steps"
            actions={
              canCreateEventProcedureSteps && (
                <Button bsStyle="primary" onClick={() => openEventProcedureStepModal()}>
                  <Icon name="add" size="xs" />
                  Create Event Procedure Step
                </Button>
              )
            }
          />
        )}
      </Col>
      <StyledIndexRow>
        <StyledIndexWrapper>
          {viewType === 'procedures' ? (
            <ProceduresList useCoreRoutes={useCoreRoutes} />
          ) : (
            <StepsList useCoreRoutes={useCoreRoutes} />
          )}
        </StyledIndexWrapper>
      </StyledIndexRow>
    </>
  );
}

export default SecurityUI;
